import React, { useEffect, useMemo, useState } from "react";
import Navbar from "./Navbar";
import { db } from "./firebase";

import {
  collection,
  getDocs,


  orderBy,
  query
} from "firebase/firestore";

import "./navbar-spacing.css";

const C = {
  bg: "#0a0a0f",
  surface: "rgba(255,255,255,0.04)",
  surfaceHover: "rgba(255,255,255,0.07)",
  border: "rgba(255,255,255,0.08)",
  text: "#f5f5f7",
  secondary: "rgba(245,245,247,0.55)",
  tertiary: "rgba(245,245,247,0.30)",
  accent: "#0a84ff",
  green: "#30d158",
  orange: "#ff9f0a",
  purple: "#bf5af2"
};

function StatCard({ label, value, color }) {

  return (
    <div
      style={{
        flex: "1 1 180px",
        background: C.surface,
        border: `1px solid ${C.border}`,
        borderRadius: 22,
        padding: "1.2rem"
      }}
    >
      <div
        style={{
          fontSize: "0.75rem",
          color: C.secondary,
          marginBottom: "0.5rem"
        }}
      >
        {label}
      </div>

      <div
        style={{
          fontSize: "2rem",
          fontWeight: "700",
          color
        }}
      >
        {value}
      </div>
    </div>
  );

}

export default function AnalyticsAccessi() {

  const [gestoreAccessi, setGestoreAccessi] = useState([]);
  const [menuAccessi, setMenuAccessi] = useState([]);
  const [asportoAccessi, setAsportoAccessi] = useState([]);

  const [loading, setLoading] = useState(true);

  const [filter, setFilter] = useState("all");

  const [isMobile, setIsMobile] = useState(
  window.innerWidth < 700
);

useEffect(() => {

  const onResize = () => {
    setIsMobile(window.innerWidth < 700);
  };

  window.addEventListener("resize", onResize);

  return () => {
    window.removeEventListener("resize", onResize);
  };

}, []);

  useEffect(() => {

    const loadAnalytics = async () => {

      try {

        const [
          gestoreSnap,
          menuSnap,
          asportoSnap
        ] = await Promise.all([

          getDocs(
            query(
              collection(db, "analytics_gestore"),
              orderBy("timestamp", "desc")
            )
          ),

          getDocs(
            query(
              collection(db, "analytics_menuview"),
              orderBy("timestamp", "desc")
            )
          ),

          getDocs(
            query(
              collection(db, "analytics_asporto"),
              orderBy("timestamp", "desc")
            )
          )

        ]);

        setGestoreAccessi(
          gestoreSnap.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
          }))
        );

        setMenuAccessi(
          menuSnap.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
          }))
        );

        setAsportoAccessi(
          asportoSnap.docs.map(doc => ({
            id: doc.id,
            ...doc.data()
          }))
        );

      } catch (err) {

        console.error(
          "❌ Errore caricamento analytics:",
          err
        );

      } finally {

        setLoading(false);

      }

    };

    loadAnalytics();

  }, []);


  const totalGestore = useMemo(() => {

    const unique = new Map();

    gestoreAccessi.forEach((g) => {

      const locale =
        g.localeTag || "unknown";

      const user =
        g.userId ||
        g.email ||
        g.userEmail ||
        "anon";

      const ts =
        g.timestamp?.seconds || 0;

      const dayKey =
        Math.floor(
          ts / (60 * 60 * 24)
        );

      const key =
        `${locale}_${user}_${dayKey}`;

      if (!unique.has(key)) {
        unique.set(key, g);
      }

    });

    return unique.size;

  }, [gestoreAccessi]);

  const totalMenu =
    menuAccessi.length;

  const totalAsporto =
    asportoAccessi.length;

  const totalDemo = useMemo(() => {

    return [
      ...gestoreAccessi,
      ...menuAccessi,
      ...asportoAccessi
    ].filter(d => d.demo === true).length;

  }, [
    gestoreAccessi,
    menuAccessi,
    asportoAccessi
  ]);

  const groupedMenuAccessi = useMemo(() => {

  const grouped = {};

  menuAccessi.forEach((item) => {

    const key =
      `${item.localeTag}_${item.tableId}_${item.token}`;

    if (!grouped[key]) {

      grouped[key] = {
        ...item,
        accessCount: 1,
        lastTimestamp:
          item.timestamp?.seconds || 0
      };

    } else {

      grouped[key].accessCount += 1;

      const currentTs =
        item.timestamp?.seconds || 0;

      if (
        currentTs >
        grouped[key].lastTimestamp
      ) {

        grouped[key] = {
          ...grouped[key],
          ...item,
          lastTimestamp: currentTs
        };

      }

    }

  });

  return Object.values(grouped);

}, [menuAccessi]);

  return (
    <>
      <Navbar />

      <div
        style={{
          minHeight: "100vh",
          background: C.bg,
          color: C.text,
          padding: isMobile ? "1rem" : "2rem"
        }}
      >

        <div
          className="page-with-navbar"
          style={{
            maxWidth: "1300px",
            margin: "0 auto"
          }}
        >

          {/* HEADER */}
          <div
            style={{
              marginBottom: "2rem"
            }}
          >
            <div
              style={{
                fontSize: "0.78rem",
                color: C.secondary,
                marginBottom: "0.5rem"
              }}
            >
              Analytics
            </div>

            <h1
              style={{
                margin: 0,
                fontSize: isMobile ? "1.5rem" : "2.2rem"
              }}
            >
              Analytics Accessi
            </h1>
          </div>

          {/* FILTRI */}
          <div
            style={{
              display: "flex",
              gap: "0.6rem",
              marginBottom: "1.5rem",
              flexWrap: "wrap"
            }}
          >

            {[
              { key: "all", label: "Tutti" },
              { key: "demo", label: "Demo" },
              { key: "menu", label: "MenuView" },
              { key: "asporto", label: "Asporto" },
              { key: "gestore", label: "Gestori" }
            ].map(btn => (

              <button
                key={btn.key}
                onClick={() => setFilter(btn.key)}
                style={{
                  border: "none",
                  borderRadius: "999px",
                  padding: "0.7rem 1rem",
                  cursor: "pointer",
                  background:
                    filter === btn.key
                      ? C.accent
                      : C.surface,
                  color: "#fff",
                  fontWeight: "600"
                }}
              >
                {btn.label}
              </button>

            ))}

          </div>

          {/* STATS */}
          <div
            style={{
              display: "flex",
              gap: "1rem",
              flexWrap: "wrap",
              marginBottom: "2rem"
            }}
          >

            <StatCard
              label="Accessi gestore"
              value={totalGestore}
              color={C.accent}
            />

            <StatCard
              label="Aperture Menu"
              value={totalMenu}
              color={C.green}
            />

            <StatCard
              label="Accessi Asporto"
              value={totalAsporto}
              color={C.orange}
            />

            <StatCard
              label="Demo"
              value={totalDemo}
              color={C.purple}
            />

          </div>

          {/* TABELLA */}
          <div
            style={{
              background: C.surface,
              border: `1px solid ${C.border}`,
              borderRadius: "22px",
              overflowX: "auto"
            }}
          >

            <div
              style={{
                display: "grid",
                gridTemplateColumns:
                  isMobile
                    ? "1fr"
                    : "1fr 1fr 1.2fr 0.8fr 1fr",
                padding: "1rem",
                borderBottom:
                  `1px solid ${C.border}`,
                fontSize: "0.75rem",
                color: C.secondary,
                fontWeight: "600"
              }}
            >
              <div>Tipo</div>
<div>Origine</div>
<div>Locale</div>
<div>Tavolo</div>
<div>Data</div>
            </div>

            {!loading && [

              ...groupedMenuAccessi.map(d => ({
                ...d,
                type: "MenuView"
              })),

              ...asportoAccessi.map(d => ({
                ...d,
                type: "Asporto"
              })),

              ...gestoreAccessi.map(d => ({
                ...d,
                type: "Gestore"
              }))

            ]
              .sort((a, b) => {
                const ta = a.timestamp?.seconds || 0;
                const tb = b.timestamp?.seconds || 0;
                return tb - ta;
              })
              .filter(item => {

                if (filter === "all")
                  return true;

                if (
                  filter === "demo"
                )
                  return item.demo === true;

                if (
                  filter === "menu"
                )
                  return item.type === "MenuView";

                if (
                  filter === "asporto"
                )
                  return item.type === "Asporto";

                if (
                  filter === "gestore"
                )
                  return item.type === "Gestore";

                return true;

              })
              .slice(0, 300)
              .map(item => (

                <div
                  key={item.id}
                  style={{
                    display: "grid",
                    gridTemplateColumns:
                      isMobile
                        ? "1fr"
                        : "1fr 1fr 1.2fr 0.8fr 1fr",
                    padding: "1rem",
                    borderBottom:
                      `1px solid ${C.border}`,
                    fontSize: "0.85rem"
                  }}
                >


                  {isMobile ? (

                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        gap: "0.4rem",
                        background: "rgba(255,255,255,0.03)",
                        borderRadius: 16,
                        padding: "0.8rem"
                      }}
                    >

                      <div>
                        <strong>Tipo:</strong> {item.type}
                      </div>

                      <div>
                        <strong>Origine:</strong>{" "}
                        {item.source === "qr_real"
                          ? "QR Cliente"
                          : item.source === "preview_admin"
                          ? "Preview/Admin"
                          : item.source === "asporto"
                          ? "Asporto"
                          : "Gestore"}
                      </div>

                      <div>
                        <strong>Locale:</strong>{" "}
                        {item.localeTag || "-"}
                      </div>


                      <div>
                        <strong>Tavolo:</strong>{" "}
                        {item.tableId || "-"}

                        {item.type === "MenuView" &&
                          item.accessCount > 1 && (
                            <div
                              style={{
                                color: C.green,
                                marginTop: "0.25rem",
                                fontSize: "0.8rem"
                              }}
                            >
                              {item.accessCount} accessi
                            </div>
                          )}
                      </div>

                      <div>
                        <strong>Data:</strong>{" "}
                        {item.timestamp?.seconds
                          ? new Date(
                              item.timestamp.seconds * 1000
                            ).toLocaleString("it-IT")
                          : "-"}
                      </div>

                    </div>

                  ) : (

                    <>
                      <div>
                        {item.type}
                      </div>

                      <div>
                        {item.source === "qr_real"
                          ? "QR Cliente"
                          : item.source === "preview_admin"
                          ? "Preview/Admin"
                          : item.source === "asporto"
                          ? "Asporto"
                          : "Gestore"}
                      </div>

                      <div>
                        {item.localeTag || "-"}
                      </div>

                      <div>
                        <>
                          {item.tableId || "-"}

                          {item.type === "MenuView" &&
                            item.accessCount > 1 && (
                              <div
                                style={{
                                  fontSize: "0.72rem",
                                  color: C.green,
                                  marginTop: "0.2rem"
                                }}
                              >
                                {item.accessCount} accessi
                              </div>
                            )}
                        </>
                      </div>

                      <div>
                        {item.timestamp?.seconds
                          ? new Date(
                              item.timestamp.seconds * 1000
                            ).toLocaleString("it-IT")
                          : "-"}
                      </div>
                    </>
                  )}

                </div>

              ))}

          </div>

        </div>

      </div>
    </>
  );
}